import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import TaskManagement_admin_001 from './img/TaskManagement_admin_001.png'
import TaskManagement_admin_002 from './img/TaskManagement_admin_002.png'
import TaskManagement_admin_003 from './img/TaskManagement_admin_003.png'
import TaskManagement_admin_004 from './img/TaskManagement_admin_004.png'


export default class AdminTaskManagement extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">管理员管理任务的整体流程</div>
        <img src={TaskManagement_admin_001} className="main-window-img"></img>
        <img src={TaskManagement_admin_002} className="main-window-img"></img>
        <img src={TaskManagement_admin_003} className="main-window-img"></img>
        <img src={TaskManagement_admin_004} className="main-window-img"></img>
      </div>
    )
  }
}
